import { useId, useState } from "react";
import { MAX_ZNAKOW_NOTATKI } from "@shared/recenzjeTypy.js";
import { useAkcjePrzegladu } from "../../hooks/usePrzegladRecenzji.js";
import { Card } from "../ui/Card.js";
import { Textarea } from "../ui/Field.js";

/**
 * "Twoje know-how do tej rozmowy": wolny tekst o regulach i rozroznieniach, ktore model powinien znac. Zapisuje sie sam
 * (po przerwie w pisaniu i po wyjsciu z pola); nic nie zmienia metodyki automatycznie - wnioski przenosi do niej czlowiek.
 */
export function KartaNotatki({ poczatkowa }: { poczatkowa: string }): React.JSX.Element {
  const akcje = useAkcjePrzegladu();
  const id = useId();
  // Notatka niezapisana w poprzedniej wizycie (np. zapis sie nie udal) wygrywa z tym, co ma serwer.
  const [tekst, setTekst] = useState(() => akcje.wczytanaNotatka() ?? poczatkowa);

  return (
    <Card tytul="Twoje know-how do tej rozmowy">
      <div className="rec-notatka">
        <Textarea
          etykieta="Reguły, rozróżnienia, rzeczy, które model powinien wiedzieć"
          id={`${id}-notatka`}
          hint="Wolny tekst. Przenosimy go do metodyki po wspólnym przeglądzie."
          maxLength={MAX_ZNAKOW_NOTATKI}
          value={tekst}
          onChange={(e) => {
            setTekst(e.target.value);
            akcje.zapiszNotatke(e.target.value);
          }}
          onBlur={akcje.splusczNotatke}
        />
      </div>
    </Card>
  );
}
